import { Link, useParams } from 'react-router-dom'
import useAuth from '../hooks/useAuth'

function SchoolNav({active=null, school={}}) {

  const { id } = useParams()
  const { can } = useAuth()

  return (
    <div className="mb-4">
      <div className="bg-white rounded-md shadow-md py-3 px-4 overflow-x-auto">
        <ul className="flex px-0">
          <Link to={`/schools/${id}`} state={school}>
            <li className={`tab-btn ${active === 'details' ? 'active' : ''}`}>
              Details
            </li>
          </Link>
          {can('access school cyp clients') && (
            <Link to={`/schools/${id}/clients/cyp`} state={school}>
              <li className={`tab-btn ${active === 'cyp-clients' ? 'active' : ''}`}>
                CYP Clients
              </li>
            </Link>
          )}
          {can('access school oh clients') && (
            <Link to={`/schools/${id}/clients/oh`} state={school}>
              <li className={`tab-btn ${active === 'oh-clients' ? 'active' : ''}`}>
                OH Clients
              </li>
            </Link>
          )}
          <Link to={`/schools/${id}/insurer`} state={school}>
            <li className={`tab-btn ${active === 'insurer' ? 'active' : ''}`}>
              Insurer
            </li>
          </Link>      
        </ul>
      </div>
    </div>
  )

}

export default SchoolNav